var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 3C6.18629 3 3.5 5.68629 3.5 9V48C3.5 51.3137 6.18629 54 9.5 54H21.5V69L46.5 54H63.5C66.8137 54 69.5 51.3137 69.5 48V9C69.5 5.68629 66.8137 3 63.5 3H9.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 54H24.5C24.5 52.3431 23.1569 51 21.5 51V54ZM21.5 69H18.5C18.5 70.0808 19.0814 71.0781 20.0219 71.6106C20.9624 72.1431 22.1167 72.1286 23.0435 71.5725L21.5 69ZM46.5 54V51C45.9563 51 45.4228 51.1478 44.9565 51.4275L46.5 54ZM6.5 9C6.5 7.34315 7.84315 6 9.5 6V0C4.52944 0 0.5 4.02944 0.5 9H6.5ZM6.5 48V9H0.5V48H6.5ZM9.5 51C7.84314 51 6.5 49.6569 6.5 48H0.5C0.5 52.9706 4.52943 57 9.5 57V51ZM21.5 51H9.5V57H21.5V51ZM24.5 69V54H18.5V69H24.5ZM44.9565 51.4275L19.9565 66.4275L23.0435 71.5725L48.0435 56.5725L44.9565 51.4275ZM63.5 51H46.5V57H63.5V51ZM66.5 48C66.5 49.6569 65.1569 51 63.5 51V57C68.4706 57 72.5 52.9706 72.5 48H66.5ZM66.5 9V48H72.5V9H66.5ZM63.5 6C65.1569 6 66.5 7.34315 66.5 9H72.5C72.5 4.02944 68.4706 0 63.5 0V6ZM9.5 6H63.5V0H9.5V6Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 21H54.5",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 36H45.5",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatEmptyState);
export default __webpack_public_path__ + "static/media/chat-empty-state.26f7e3d925e63940659684cf7328e718.svg";
export { ForwardRef as ReactComponent };